<template>
	<div class="component">
		<div>
			<van-uploader :after-read="afterRead" :accept="accept" v-model="fileList" :max-size="2000 * 1024"
			              @oversize="onOversize"
			              multiple :max-count="1"/>
		</div>
	</div>
</template>

<script>
import {upload} from '../../../api/contactWelcome'

export default {
	data() {
		return {
			fileList: [],
			accept: 'image/*'
		}
	},
	watch: {},
	methods: {
		get(type) {
			switch (Number(type)) {
				case 4:
					this.accept = '.amr'
					break;
				case 5:
					this.accept = '.mp4'
					break;
				case 7:
					this.accept = '*'
					break;
			}
		},
		setFile(data) {
			this.fileList = [data]
		},
		// 文件大小
		onOversize(file) {
			this.$message.warning('文件大小不能超过 2MB');
		},
		// 上传文件
		afterRead(file) {
			var formData = new FormData();
			formData.append('file', file.file);
			upload(formData).then(res => {
				// this.items.title = res.data.name
				this.$emit('change', {
					url: res.data.fullPath,
					path: res.data.path,
					name: res.data.name
				})
			})

		}

	},
	mounted() {
		this.$nextTick(function () {
			this.$on('setFile', function (data) {
				this.setFile(data)
			});
		});
	},
}
</script>

<style lang="less" scoped>

/deep/ .van-action-sheet__header {
	font-weight: bolder;
}

.component {
	.content {
		padding: 0;

		.ttips {
			/deep/ .van-icon {
				font-size: var(--base-px-14) !important;
				color: #1890ff !important;
				margin-right: var(--base-px-5) !important;
			}

			font-size: var(--base-px-12);
			padding: var(--base-px-5) var(--base-px-14);
			background: #effaff;
			margin: var(--base-px-7) var(--base-px-7);
		}

		.user-list {
			height: var(--base-px-275);
			overflow: auto;

			.user {
				display: flex;
				align-items: center;
				justify-content: space-between;

				div {
					font-size: var(--base-px-14);
					color: #252528;

					img {
						width: var(--base-px-46);
						height: var(--base-px-46);
						margin-right: var(--base-px-6);
					}
				}
			}

			.active-background {
				background: #f6fbff !important;
			}
		}
	}
}
</style>
